<template>
  <div>
    <van-popup round :close-on-click-overlay='false' v-model="qrcodePicShow1">
      <div class="delogMain">
        <img
          src="../../../assets/img/icon-close.png"
          class="close"
          @click="closeShow"
          alt=""
        />
        <div class="pic">
          <img :src="posterObj.src?posterObj.src:qrcodePic" alt=""/>
          <p>万顺叫车代驾小程序</p>
          <div class="tips">截屏或长按图片 立即打车</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  export default {
    props: ['qrcodePicShow', 'posterObj', 'params'],
    data() {
      return {
        qrcodePicShow1: false,
        qrcodePic: ''
      };
    },
    watch: {
      qrcodePicShow: {//深度监听，可监听到对象、数组的变化
        handler(val) {
          this.qrcodePicShow1 = val;
           this.poster();
        },
        deep: true //true 深度监听
      },
      posterObj: {//深度监听，可监听到对象、数组的变化
        handler(val) {
          if (!val.src) {
            this.poster();
          }
        },
        deep: true, //true 深度监听
        immediate: true,
      },
    },
    created() {
    },
    mounted(){
      // this.poster();
    },
    methods: {
      //分享弹窗关闭
      closeShow() {
        this.qrcodePicShow1 = false;
        this.$emit('setShow', false);
      },
      //分享的二维码
      async poster() {
        let scene = '';
        if (this.posterObj.outreachChannelCode) {
          scene = this.posterObj.activityId + '&' + this.posterObj.outreachChannelCode;
        } else {
          scene = this.posterObj.activityId;
        }
        let QRCodeObj = {
          scene: scene,
          page: this.posterObj.page,
        };
        try {
          let imgUrl = await this.$apiFun.getAppletQRCodeFun(
            this.params,
            QRCodeObj
          );
          this.qrcodePic = imgUrl;
        } catch (error) {
        }
      },
    },
  };
</script>
<style lang="less" scoped>
  .delogMain {
    position: relative;
    padding: 40px 20px 20px 20px;
    box-sizing: border-box;

    .close {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 20px;
      height: 20px;
    }

    .pic {
      text-align: center;
      width: 200px;

      img {
        width: 100%;
        margin: 0 auto;
        display: block;
      }

      p {
        font-size: 14px;
        font-weight: 500;
        color: #666;
        line-height: 22px;
        margin: 20px 0;
      }

      .tips {
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        line-height: 22px;
      }
    }

  }
</style>

